"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});

var _Hidden = _interopRequireDefault(require("./Hidden"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Hidden/index.js
 ** module id = 871
 ** module chunks = 0
 **/